// src/utils/constants.js
export const SYSTEM_LIMIT = 12;

export const getTierSlotCount = (tier) => {
  switch (tier) {
    case 5:
      return 45;
    case 4:
      return 18;
    case 3:
      return 9;
    case 2:
      return 3;
    case 1:
    default:
      return 0;
  }
};
